<button
  class="btn"
  [attr.aria-label]="ariaLabel"
  [attr.type]="buttonSubmit ? 'submit' : 'button'"
  [disabled]="type === 'disabled'">

  <div
    *ngIf="!loading"
    class="button-inner">
    <svg
      *ngIf="icon"
      [class.separator]="hasIconAndText">
      <use
        attr.href="#{{icon}}"
        href="" />
    </svg>
    <span
      #buttonText
      class="button-text">
      <ng-content></ng-content>
    </span>
  </div>
</button>
